<template>
  <div class="animate-fade-in">
    <section class="bg-carpatina-verde py-16 px-4 text-center text-white">
      <h1 class="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-4">Contactează-ne</h1>
      <p class="text-lg opacity-80 max-w-2xl mx-auto italic">
        Echipa Carpatina Prodcom este gata să te ajute cu cele mai bune materiale pentru proiectul tău. Cere o ofertă sau vizitează-ne la depozit!
      </p>
    </section>

    <section class="max-w-6xl mx-auto px-4 py-16 grid grid-cols-1 lg:grid-cols-3 gap-12">
      <div class="space-y-8">
        <div>
          <h3 class="text-2xl font-black text-carpatina-gri uppercase mb-6 flex items-center gap-3">
            <span class="bg-carpatina-portocaliu w-2 h-8 block"></span> Detalii de Contact
          </h3>
          <div class="space-y-6">
            <div class="flex items-start gap-4">
              <div class="bg-white p-3 rounded-2xl shadow-md text-carpatina-verde">
                <PhoneCall :size="24" />
              </div>
              <div>
                <p class="text-xs font-black uppercase text-gray-400">Telefon Vânzări</p>
                <a href="tel:0247412068" class="text-lg font-bold text-carpatina-gri hover:text-carpatina-portocaliu transition">0247 412 068</a>
              </div>
            </div>

            <div class="flex items-start gap-4">
              <div class="bg-white p-3 rounded-2xl shadow-md text-carpatina-verde">
                <MapPin :size="24" />
              </div>
              <div>
                <p class="text-xs font-black uppercase text-gray-400">Locație Depozit</p>
                <p class="text-lg font-bold text-carpatina-gri">Strada Stadionului NR 14, Turnu Magurele</p>
              </div>
            </div>

            <div class="flex items-start gap-4">
              <div class="bg-white p-3 rounded-2xl shadow-md text-carpatina-verde">
                <Mail :size="24" />
              </div>
              <div>
                <p class="text-xs font-black uppercase text-gray-400">Email Suport</p>
                <p class="text-lg font-bold text-carpatina-gri">carpatina2007@yahoo.com</p>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-carpatina-gri p-6 rounded-3xl text-white shadow-xl">
          <p class="font-black uppercase text-xs mb-4 tracking-widest text-carpatina-portocaliu">Urmărește-ne</p>
          <div class="flex gap-4">
            <a href="https://www.facebook.com/CarpatinaProdcom/" target="_blank">
              <Facebook class="cursor-pointer hover:scale-110 transition"/>
            </a>
          </div>
        </div>
      </div>

      <div class="lg:col-span-2 bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-b-8 border-carpatina-portocaliu">
        <h3 class="text-3xl font-black text-carpatina-verde uppercase mb-8 tracking-tighter">Trimite-ne un mesaj</h3>
        
        <form @submit.prevent="handleContact" class="space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="space-y-2">
              <label class="text-xs font-black uppercase text-gray-400 ml-1">Nume Complet</label>
              <div class="relative">
                <User class="absolute left-3 top-3 text-gray-300" :size="20" />
                <input v-model="form.nume_client" required type="text" placeholder="Ex: Ion Popescu"
                       class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition">
              </div>
            </div>
            <div class="space-y-2">
              <label class="text-xs font-black uppercase text-gray-400 ml-1">Număr Telefon</label>
              <div class="relative">
                <Phone class="absolute left-3 top-3 text-gray-300" :size="20" />
                <input v-model="form.telefon" required type="tel" placeholder="07xx xxx xxx"
                       class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition">
              </div>
            </div>
          </div>

          <div class="space-y-2">
            <label class="text-xs font-black uppercase text-gray-400 ml-1">Email (Opțional)</label>
            <div class="relative">
              <AtSign class="absolute left-3 top-3 text-gray-300" :size="20" />
              <input v-model="form.email" type="email" placeholder="email@exemplu.ro"
                     class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition">
            </div>
          </div>

          <div class="space-y-2">
            <label class="text-xs font-black uppercase text-gray-400 ml-1">Mesajul tău</label>
            <div class="relative">
              <MessageSquare class="absolute left-3 top-4 text-gray-300" :size="20" />
              <textarea v-model="form.mesaj" required rows="5" placeholder="Descrie materialele de care ai nevoie..."
                        class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-verde outline-none transition"></textarea>
            </div>
          </div>

          <button type="submit" :disabled="loading"
                  class="w-full bg-carpatina-verde hover:bg-opacity-95 text-white font-black py-5 rounded-2xl shadow-lg transition-all transform hover:-translate-y-1 active:scale-95 flex items-center justify-center gap-3 uppercase tracking-widest">
            <Send v-if="!loading" :size="20" />
            <span>{{ loading ? 'Se trimite...' : 'Trimite Solicitarea' }}</span>
          </button>
        </form>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { 
  PhoneCall, MapPin, Mail, Facebook,
  User, Phone, AtSign, MessageSquare, Send 
} from 'lucide-vue-next';

const loading = ref(false);
const form = ref({
  nume_client: '',
  telefon: '',
  email: '',
  mesaj: ''
});

onMounted(() => {
  // --- SETĂRI SEO DINAMICE ---
  document.title = "Contactează-ne | Carpatina Prodcom Turnu Măgurele";
  
  const metaDescription = document.querySelector('meta[name="description"]') 
                          || document.createElement('meta');
  metaDescription.name = "description";
  metaDescription.content = "Ai nevoie de o ofertă personalizată pentru materiale de construcții? Contactează echipa Carpatina Prodcom sau vizitează-ne la depozitul nostru din Turnu Măgurele. Suntem aici să te ajutăm cu stocuri reale și livrare rapidă.";
  
  if (!document.querySelector('meta[name="description"]')) {
    document.head.appendChild(metaDescription);
  }
});

const handleContact = async () => {
  loading.value = true;
  
  const formData = new FormData();
  formData.append('nume_client', form.value.nume_client);
  formData.append('telefon', form.value.telefon);
  if (form.value.email) formData.append('email', form.value.email);
  formData.append('mesaj', form.value.mesaj);

  try {
    await axios.post('/contact', formData);
    
    Swal.fire({
      title: 'Mesaj Trimis!',
      text: 'Briciule, te contactăm noi imediat pentru ofertă!',
      icon: 'success',
      confirmButtonColor: '#00684a'
    });

    form.value = { nume_client: '', telefon: '', email: '', mesaj: '' };
  } catch (err) {
    Swal.fire('Eroare', 'Nu am putut trimite mesajul. Încearcă să ne suni!', 'error');
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.5s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>